module.exports = __webpack_public_path__ + "img/weihuo.c5e9c997.png";